import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import jwtInterceptor from './helpers/auth/auth-header';
import { authService } from './helpers/auth/auth.service';
import LoadScript from "vue-plugin-load-script";
import { GesturePlugin } from '@vueuse/gesture';

jwtInterceptor();
authService.refreshToken();
createApp(App).use(store).use(router).use(LoadScript).use(GesturePlugin).mount('#app')
